'use client';

import { shallow } from 'zustand/shallow';
import { EmptyState } from '../OffersFilter/EmptyState';
import { useGetOffersFilterOffers } from '../roundups/OffersFilter/store/hooks';
import { useOffersFilterStore } from '../roundups/OffersFilter/store/useOffersFilterStore';
import { SummaryTableSection } from './SummaryTableSection';
import type { SummaryTableSectionProps } from './types';

export function SummaryTableSectionWithOffersStore(props: SummaryTableSectionProps) {
  const isFilterLoading = useOffersFilterStore(state => state.isLoading, shallow);
  const rows = useGetOffersFilterOffers();

  return rows.length > 0 ? (
    <SummaryTableSection {...props} rows={rows} isFilterLoading={isFilterLoading} isFilterActive />
  ) : (
    <EmptyState />
  );
}
